import styled from 'styled-components';

export const UploadedContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 8px;
  border: 1px solid ${({ theme }) => theme.colors.black4};
  border-radius: 8px;
  background-color: ${({ theme }) => theme.colors.white};
  gap: 8px;
  width: 100%;
  min-height: 54px;
  box-sizing: border-box;

  @media (min-width: ${({ theme }) => theme.mediaQueries.md}) {
    padding: 12px;
    min-height: 58px;
  }
`;

export const FileInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;
  min-width: 0;
  cursor: pointer;
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 0.7;
  }

  @media (min-width: ${({ theme }) => theme.mediaQueries.md}) {
    gap: 12px;
  }
`;

export const FileIconWrapper = styled.div<{ $iconColor: string }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background-color: ${({ $iconColor }) => $iconColor};
  color: ${({ theme }) => theme.colors.white};
  flex-shrink: 0;

  svg {
    fill: currentColor;
  }

  @media (min-width: ${({ theme }) => theme.mediaQueries.md}) {
    width: 32px;
    height: 32px;
  }
`;

export const FileName = styled.p`
  font-size: 14px;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.black8};
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: 1;
  min-width: 0;
`;

export const ActionsWrapper = styled.div`
  display: flex;
  gap: 4px;
  flex-shrink: 0;

  .ant-btn-text {
    min-width: 32px;
    min-height: 32px;
    padding: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;
